function escapeHtml() {
  var value = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : '';
  return String(value).replace(/&/g, '&amp;').replace(/</g, '&lt;').replace(/>/g, '&gt;').replace(/"/g, '&quot;');
}
function formatAmount(value) {
  var amount = Number(value);
  if (!Number.isFinite(amount)) {
    return '0';
  }
  return amount.toLocaleString('en-US', {
    maximumFractionDigits: 8
  });
}
function formatPendingDate(value) {
  if (!value) {
    return '';
  }
  var date = new Date(value);
  if (Number.isNaN(date.getTime())) {
    return '';
  }
  var year = date.getFullYear();
  var month = String(date.getMonth() + 1).padStart(2, '0');
  var day = String(date.getDate()).padStart(2, '0');
  return "".concat(year, "-").concat(month, "-").concat(day);
}
module.exports = function () {
  var _ref = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
    _ref$rows = _ref.rows,
    rows = _ref$rows === void 0 ? [] : _ref$rows;
  var body = rows.length ? rows.map(function (row) {
    var ticker = escapeHtml(row.ticker);
    var available = Number(row.available);
    var pending = Number(row.pending);
    var canWithdraw = Number.isFinite(available) && available > 0;
    var pendingDate = Number.isFinite(pending) && pending > 0 ? formatPendingDate(row.pending_on) : '';
    var withdraw = canWithdraw ? "<button type=\"button\" class=\"withdraw-link\" data-action=\"withdraw\" data-ticker=\"".concat(ticker, "\">withdraw</button>") : '';
    var date = pendingDate ? "<time datetime=\"".concat(escapeHtml(pendingDate), "\">").concat(escapeHtml(pendingDate), "</time>") : '';
    return "\n            <tr>\n              <th scope=\"row\">".concat(ticker, "</th>\n              <td>\n                <div class=\"available\">\n                  <span class=\"amount\">").concat(escapeHtml(formatAmount(available)), "</span>\n                  <span class=\"label\">available</span>\n                  ").concat(withdraw, "\n                </div>\n                <div class=\"pending\">\n                  <span class=\"amount\">").concat(escapeHtml(formatAmount(pending)), "</span>\n                  <span class=\"label\">pending</span>\n                  ").concat(date, "\n                </div>\n              </td>\n            </tr>");
  }).join('') : "<tr><td class=\"empty\" colspan=\"2\">No web3 currencies are available from this server.</td></tr>";
  return "\n    <section class=\"store-withdrawals\">\n      <h2 class=\"title\">Your web3 crypto balance:</h2>\n      <table class=\"balances\">\n        <tbody>".concat(body, "</tbody>\n      </table>\n    </section>\n  ");
};